import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('map_fragment', {
  cherry: 'scroll',
  lemon: 'quill',
  orange: 'spyglass',
  bell: 'sextant',
  star: 'treasure_map_wild',
  seven: 'wax_seal',
  gem: 'sapphire',
  scatter: 'message_bottle_scatter',
  money: 'doubloon_stack',
});

/** Map Fragment — GENERATED by scaffoldSlot from
 *  content/slots/map_fragment.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const MAP_FRAGMENT_THEME: Theme = {
  id: 'map_fragment',
  name: 'Map Fragment',
  palette: {
    accent: 0xc9a24b,
    secondary: 0x4a6b78,
    warm: 0xe8d6a8,
    frameFill: 0x2a2018,
    bgGradientTop: 0x3a2e22,
    bgGradientBottom: 0x140f0a,
    dimOverlay: 0x0a0805,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Scroll', glyph: '📜', tint: 0xe8d6a8, weight: 5, textureAlias: 'map_fragment:cherry',
        winVideoAlias: 'map_fragment:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Quill', glyph: '🪶', tint: 0xd8c0a0, weight: 5, textureAlias: 'map_fragment:lemon',
        winVideoAlias: 'map_fragment:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Spyglass', glyph: '🔭', tint: 0xc9a24b, weight: 4, textureAlias: 'map_fragment:orange',
        winVideoAlias: 'map_fragment:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Sextant', glyph: '📐', tint: 0xc9a24b, weight: 3, textureAlias: 'map_fragment:bell',
        winVideoAlias: 'map_fragment:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Treasure Map', glyph: '🗺️', tint: 0xe8d6a8, weight: 2, textureAlias: 'map_fragment:star',
        winVideoAlias: 'map_fragment:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Wax Seal', glyph: '🔴', tint: 0xb83a3a, weight: 2, textureAlias: 'map_fragment:seven',
        winVideoAlias: 'map_fragment:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Sapphire', glyph: '💎', tint: 0x3a6bc9, weight: 2.5, textureAlias: 'map_fragment:gem',
        winVideoAlias: 'map_fragment:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Message Bottle', glyph: '🍾', tint: 0x9fb8c0, weight: 0.5, textureAlias: 'map_fragment:scatter',
        winVideoAlias: 'map_fragment:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Doubloon Stack', glyph: '🪙', tint: 0xf0c860, weight: 1, textureAlias: 'map_fragment:money',
        winVideoAlias: 'map_fragment:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a2018, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xc9a24b, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xe8d6a8, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x4a6b78, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xc9a24b, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xe8d6a8, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xe8d6a8, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a2018, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x4a6b78, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xc9a24b, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xe8d6a8, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xe8d6a8, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'map_fragment:bg', path: 'environment/map_fragment.png' },
      columnBackground: { alias: 'map_fragment:column_bg', path: 'reel/map_fragment_column_bg.png' },
      border: { alias: 'map_fragment:border', path: 'brand/border_underwater.png' },
    },
  },
};
